import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import MonetizationOnRoundedIcon from "@material-ui/icons/MonetizationOnRounded";
import PlaylistAddCheckRoundedIcon from "@material-ui/icons/PlaylistAddCheckRounded";
import PublishRoundedIcon from "@material-ui/icons/PublishRounded";
import PostAddRoundedIcon from "@material-ui/icons/PostAddRounded";
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import DoneOutlineRoundedIcon from "@material-ui/icons/DoneOutlineRounded";
import InsertDriveFileRoundedIcon from "@material-ui/icons/InsertDriveFileRounded";

import { FinancingData, ArchiveData } from "../../../shared/data/types";

export const getFinancingCta = (financing: FinancingData) => {
  let cta = {
    txt: "CONTRATAR",
    icon: <MonetizationOnRoundedIcon />,
  };

  if (!!financing) {
    const addedToPropOpts =
      financing.proposals?.filter((p) => p?.addedToProp)?.length || 0;
    const hasChosenProp = !!financing.proposals?.find((p) => p?.chosen);

    if (!addedToPropOpts && !hasChosenProp) {
      cta = {
        txt: "ADD À PROPOSTA",
        icon: <PostAddRoundedIcon />,
      };
    } else if (!hasChosenProp) {
      cta = {
        txt: "SELECIONAR OPÇÃO",
        icon: <PlaylistAddCheckRoundedIcon />,
      };
    }
  }

  return cta;
};
